import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/Header";
import Task from "./components/Task";

function App() {
  return (
    <div className="App">
      <Header />
      <Task />
    </div>
  );
}

export default App;